import { Component, OnInit, Injectable } from '@angular/core';

import { Http, URLSearchParams } from '@angular/http';

import { Router, ActivatedRoute, ParamMap, NavigationEnd } from '@angular/router';

import { DomSanitizer, Meta, Title } from '@angular/platform-browser';

//declare let ga: Function;

@Injectable()
export class MarkLogicService {

  constructor(private http: Http) {
    console.log('MarkLogic Service is available...');
  }

  makeDopRequest(url: string) {
    return this.sendDopRequest(url);
  }

  private sendDopRequest(url: string) {
    return this.http.get(url);
  }

}

@Component({
  selector: 'app-definition',
  templateUrl: './definition.component.html',
  styleUrls: ['./definition.component.scss'],
  providers: [MarkLogicService]
})
export class DefinitionComponent implements OnInit {

  constructor(
      private ml: MarkLogicService,
      private _sanitizer: DomSanitizer,
      public http: Http,
      private route: ActivatedRoute,
      private router: Router,
      private meta: Meta,
      private titleService: Title
  ) {
  }

    model: any;
    termDef;
    termDefTwo: any;
    termDefRelated;
    socialShare: any;
    sub;
    truncate = false;
    truncated = false;
    relatedTerms = false;

    nodeValue: any;

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.model = this.route.snapshot.params['term'];
            this.getDopDef(this.route.snapshot.params['term']);
            this.truncate = false;
            this.truncated = false;

            this.nodeValue = String( this.route.snapshot.params['term'] ).replace(/-/g, ' ');

            //this.gasend('/'+ this.route.snapshot.params['term'], ' '+ this.route.snapshot.params['term'] +' - APA Dictionary of Psychology', 'https://dictionary.apa.org/'+ this.route.snapshot.params['term'] );
        });
    }

  getDopDef(term): void {
      this.ml.makeDopRequest('https://x6t7fqryxa.execute-api.us-east-1.amazonaws.com/dev/getdopdefinitions?q='+term)
        .subscribe(data => {
          this.termDef = this._sanitizer.bypassSecurityTrustHtml(data["_body"]);

            var stringTitleText = String(this._sanitizer.bypassSecurityTrustHtml(data["_body"]));

            var stringTitleTextClean = stringTitleText.match(/[<h4>](.*)[</h4>]/g);
            var stringTitleTextCleanTags = stringTitleTextClean[1].replace(/<[^>]+>/gm, '');

            this.setTitle(stringTitleTextCleanTags);

            var stringText =  String(data["_body"]).replace(/<[^>]+>/gm, '');
            this.termDefTwo =  this._sanitizer.bypassSecurityTrustHtml('<script type="application/ld+json"> ' +
                '[' +
                '{'+
                '"@context": "http://schema.org/"'+
                '},'+
                '{' +
                '"@type": ["CategoryCodeSet","Book"],'+
                '"@id": "https://dictionary.apa.org/",'+
                '"name": "APA Dictionary of Psychology, Second Edition",'+
                '"author": {"@type": "Organization", "name":"American Psychological Association"},'+
                '"publisher": {"@type": "Organization", "name": "American Psychological Association"}'+
                '},'+
                '{'+
                '"@type": "CategoryCode",'+
                '"@id": "https://dictionary.apa.org/'+ term.replace(/\s+/g, '-') + '",'+
                '"name": "' + term + '",'+
                '"description": "' + stringText + '",'+
                '"inCodeSet": " http://dictionary.apa.org/"'+
                '}'+
                ']' +
                '</script>');

            if(stringText.length > 655 ) {
                this.truncate = true;
                this.truncated = true;
            };

            this.meta.updateTag({ name: 'description', content: stringText });

            this.meta.updateTag({ property: 'og:title', content: stringTitleTextCleanTags + ' – APA Dictionary of Psychology' });
            this.meta.updateTag({ property: 'og:url', content: 'https://dictionary.apa.org/' + this.model });
            this.meta.updateTag({ property: 'og:image', content: 'http://www.apa.org/pubs/books/images/4311022-475.gif' });

            this.meta.updateTag({ name: 'twitter:title', content: 'Definition of ' + stringTitleTextCleanTags });
            this.meta.updateTag({ name: 'twitter:url', content: 'https://dictionary.apa.org/' + this.model  });
            this.meta.updateTag({ name: 'twitter:description', content: stringText });
            this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
            this.meta.updateTag({ name: 'twitter:site', content: '@APA' });


            this.meta.removeTag('itemprop=name');
            this.meta.removeTag('itemprop=description');
            this.meta.removeTag('itemprop=image');
            
            this.meta.updateTag({ itemprop: 'name', content: stringTitleTextCleanTags + ' – APA Dictionary of Psychology' });
            this.meta.updateTag({ itemprop: 'description', content: stringText });
            this.meta.updateTag({ itemprop: 'image', content: 'http://www.apa.org/pubs/books/images/4311022-475.gif' });

        });

  }

    public setTitle( newTitle: string) {
        this.titleService.setTitle( newTitle + ' – APA Dictionary of Psychology');
    }

/*    public gasend(gaPage, gaTitle, gaLocation){
        ga('create',"UA-10493335-13","auto");
        ga('send', {
            hitType: 'pageview',
            page: gaPage,
            title: gaTitle,
            location : gaLocation
        });
    }*/

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/app/definition/definition.component.ts